export enum SupplierDashboardFilterBy {
	all = 'ALL',
	pinned = 'PINNED',
	new = 'NEW',
	closingSoon = 'CLOSING_SOON',
	active = 'ACTIVE',
	won = 'WON',
	closed = 'CLOSED',
}
